<template>
    <div class="meals-date__weekly">
        <strong>
            {{ weekDay }}
            <span v-if="evaluation" :class="'meal-evaluation-value '+evaluationColor">{{ evaluationValue }}</span>
        </strong>
        <span>{{ fullDate }}</span>
    </div>
</template>
<script>
export default {
    props: {
        date: {
            type: String,
            required: true
        },
        evaluation: {
            type: Object,
            required: false
        }
    },
    computed: {
        weekDay() {
            if(moment(this.date).isSame(moment(), 'day')) {
                return lang.get('Today')
            } else {
                return moment(this.date).format('dddd')
            } 
        },
        fullDate() {
            return moment(this.date).format('D. MMMM YYYY')
        },
        evaluationColor() {
            if(this.evaluation['color']) {
                return this.evaluation['color']
            }
        },
        evaluationValue() {
            if(this.evaluation['value'] !== null) {
                return this.evaluation['value']
            }
        }
    }
}
</script>
